import { Typography } from 'antd';
import clsx from 'clsx';
import AppTag from 'common/components/tag.component';
import { RouteName } from 'config/constants/route.constants';
import { OrderTranscription } from 'config/constants/transcription.constant';
import { ConfirmPurchaseResponse } from 'config/types/order.type';
import { AppTagColor } from 'config/utils/catalog.util';
import React from 'react';
import { useNavigate } from 'react-router';
import { User } from 'store/models/user.model';
import PaymentActions from '../payment-actions.component';
import styles from './style.module.scss';

const { Title } = Typography;

type FailedPaymentProps = {
  user: User;
  confirmedPurchaseResponse?: ConfirmPurchaseResponse;
};

const FailedPayment: React.FC<FailedPaymentProps> = ({ user, confirmedPurchaseResponse }) => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <div className={styles['status-view-wrapper']}>
        <div className={clsx(styles['status-card'], styles['failed'])}>
          <div className={styles['icon-container']}>
            <div className={styles['circle-icon']}>x</div>
          </div>
          <Title level={2} className={styles['status-title']}>
            {OrderTranscription.ERROR_PROCESSING_PAYMENT}
          </Title>
          <div className={styles['status-description']}>
            <p>
              Estimado <strong>{user.name}</strong>, lamentamos informarte que no hemos podido procesar el pago de tu pedido.
            </p>
            {confirmedPurchaseResponse?.paymentNotes && (
              <AppTag text={`Nota: ${confirmedPurchaseResponse.paymentNotes}`} color={AppTagColor.ERROR} />
            )}
          </div>
          <PaymentActions onRetryPurchase={() => navigate(RouteName.PURCHASE_CHECKOUT)} onGoHome={() => navigate(RouteName.HOME)} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FailedPayment;
